import request from '@/utils/request';

export default function getMiniProductVerifyDetail(type, id) {
  return request({
    url: '/MiniProductVerify/detail',
    params: {
      type,
      id,
    },
  });
}
